module.exports = __webpack_public_path__ + "img/coins-gold.e32fb80d.svg";